import React, { useState, useEffect } from 'react';
import { Row, Button, Card, Container, Col, Dropdown, DropdownButton, Form } from 'react-bootstrap'
import * as Constants from './../../constants/constants.js';
import axios from 'axios';
import JobCard from "./JobCard.js"
import AddJobModal from "./Modals/AddJobModal.js"
import EditJobModal from "./Modals/EditJobModal.js"
import socket from '../../constants/socketconfig'
import Loading from "../../global_components/Loading.js"
import NoteModal from "./Modals/NoteModal.js"
import { invalidAuth } from '../../global_components/Helpers.js';
import JobsTable from './JobsTable.js';
import FilterComponent from './FilterComponent.js';
import { MDBIcon } from 'mdbreact';
export default function JobsScreen(props) {

    const [listOfJobs, setListOfJobs] = useState({ jobs: [], filtered: [] })
    const [notes, setNotes] = useState({notes: [], filtered: []})
    const [editItem, setEditItem] = useState({})
    const [apts, setApts] = useState({ show: false, list: [], filtered: [] })
    const [modals, setModals] = useState({
        addNote: false,
        editNote: false,
        addJob: false,
        addScheduledJob: false,
    })
    const [showEditJobModal, setShowEditJobModal] = useState({ show: false, job: null })
    const [loading, setLoading] = useState(false);
    const [count, setCount] = useState(0)
    const [viewJobs, setViewJobs] = useState('Both')
    const [sort, setSort] = useState('Time')
    const [filterJobs, setFilterJobs] = useState('')
    const [filterNotes, setFilterNotes] = useState('')
    const [employees, setEmployees] = useState([])
    const [notesOpen, setNotesOpen] = useState(() => localStorage.getItem("notesOpen") !== "false")


    window.onbeforeunload = () => {
        sessionStorage.clear()
    }

    function toggleNotes() {
        setNotesOpen(open => {
            localStorage.setItem("notesOpen", !open)
            return !open
        })
    }

    async function saveJobChanges(newJob) {
        try {
            await axios.post(`${Constants.port}/jobs/${newJob._id}/update`,
                Object.assign(newJob, { createWO: false })
            );
            setShowEditJobModal({ show: false, job: null })
        } catch (error) {
            console.log("CATCHING ERROR. HANDLE THIS-62311zz")
            setShowEditJobModal({ show: false, job: null })

        }
    }

    async function moveJob(newJob) {
        try {
            await axios.post(`${Constants.port}/jobs/${newJob._id}/moveJob`);
            setShowEditJobModal({ show: false, job: null })
        } catch (error) {
            console.log("CATCHING ERROR. HANDLE THIS-62311zz")
            setShowEditJobModal({ show: false, job: null })

        }
    }

    async function addJob(jobToAdd) {
        try {
            console.log("jobToAdd: ", jobToAdd)
            await axios.post(`${Constants.port}/jobs/add`, jobToAdd);
            setModals({ ...modals, addJob: false, addScheduledJob: false })
            //setListOfJobs({ jobs: res_data.data.jobs })
        } catch (error) {
            console.log("testing CATCHING ERROR. HANDLE THIS-61", error)
        }

    }

    async function addNote(noteToAdd) {
        try {
            console.log("newNote: ", noteToAdd)
            noteToAdd.CreatedTime = new Date()
            const res_data = await axios.post(`${Constants.port}/notes/add`, noteToAdd);
            console.log('fetching data addNote: ', res_data);
            setModals({ ...modals, addNote: false })
            setNotes({notes: res_data.data.notes, filtered: res_data.data.notes})
        } catch (error) {
            console.log("Error adding new note - JobScreen.js")
        }

    }

    async function updateNote(noteToUpdate) {
        try {
            console.log("noteToUpdate: ", noteToUpdate)
            noteToUpdate.LastEditTime = new Date()
            const res_data = await axios.post(`${Constants.port}/notes/${noteToUpdate._id}/update`, noteToUpdate);
            console.log('fetching data updateNote: ', res_data);
            setModals({ ...modals, editNote: false })
            setNotes({notes: res_data.data.notes, filtered: res_data.data.notes})
        } catch (error) {
            console.log("testing CATCHING ERROR. HANDLE THIS-656")
        }

    }

    async function removeNote(noteToRemove) {
        try {
            console.log("removeNote: ", noteToRemove)
            const res_data = await axios.post(`${Constants.port}/notes/${noteToRemove._id}/remove`);
            console.log('fetching data removeNote: ', res_data);
            setModals({ ...modals, editNote: false })
            setNotes({notes: res_data.data.notes, filtered: res_data.data.notes})
        } catch (error) {
            console.log("testing CATCHING ERROR. HANDLE THIS-656")
        }

    }

    async function getJobs() {
        try {
            setLoading(true)
            const res_data = await axios.get(`${Constants.port}/jobs/getAllJobs`);
            if (sessionStorage.getItem("sortJobs") === "Status")
                setListOfJobs({ ...listOfJobs, jobs: res_data.data.list_of_all_jobs.sort(compareStatus), filtered: res_data.data.list_of_all_jobs.sort(compareStatus) })
            else
                setListOfJobs({ ...listOfJobs, jobs: res_data.data.list_of_all_jobs.sort(compareTime), filtered: res_data.data.list_of_all_jobs.sort(compareTime) })

            if (sessionStorage.getItem("viewJobs") === "Table")
                setViewJobs("Table")
            else if (sessionStorage.getItem("viewJobs") === "Cards")
                setViewJobs("Cards")
            else
                setViewJobs("Both")

            setLoading(false)

        } catch (error) {
            console.log("JobsScreen: Error getting all jobs.", error)
            if (error.response)
                if (error.response.status === 403) {
                    invalidAuth(props)
                    props.history.push('/login')
                }
            setLoading(false)

        }
    }

    async function getScheduledJobs() {
        try {
            setLoading(true)
            const res_data = await axios.get(`${Constants.port}/jobs/getScheduledJobs`);
            setApts({ ...apts, list: res_data.data.apt_list.sort(compareDate), filtered: res_data.data.apt_list.sort(compareDate) })
            setLoading(false)
        } catch (error) {
            console.log("JobsScreen: Error getting all scheduled jobs.", error)
            if (error.response)
                if (error.response.status === 403) {
                    invalidAuth(props)
                    props.history.push('/login')
                }
            setLoading(false)

        }
    }

    async function getNotes() {
        try {
            setLoading(true)
            const res_data = await axios.get(`${Constants.port}/notes/getNotes`);
            setNotes({notes: res_data.data.notes, filtered: res_data.data.notes})
            setLoading(false)

        } catch (error) {
            console.log("JobsScreen: Error getting all notes.", error)
            if (error.response)
                if (error.response.status === 403) {
                    invalidAuth(props)
                    props.history.push('/login')
                }
            setLoading(false)
            return
        }
    }

    async function openWO(job) {
        console.log(job)
        try {
            setLoading(true)
            const res_data = await axios.get(`${Constants.port}/invoices/${job.WorkorderNumber}/getInvoiceByWONumber`);
            console.log('fetching dat2a: ', res_data.data.invoice._id);
            props.history.push(`/invoices/${res_data.data.invoice._id}`)
            setLoading(false)

        } catch (error) {
            console.log("Error - aslx71", error)
            if (error.response)
                props.setError({ show: true, message: error.response.data + "\n" + error.response.status + "\n" + error.response.headers })
            else if (error.request)
                props.setError({ show: true, message: error.request })
            else
                props.setError({ show: true, message: "Error getting invoices/:id/getInvoiceByWONumbers, errno: as1x71" })

        }
    }

    async function createWO_blank(customer) {
        try {
            const res_data = await axios.post(`${Constants.port}/invoices/create/blank`, { customer });
            console.log('fetching data, create blank invoice: ', res_data, "\ncustomer:", customer);
            const res_data_2 = await axios.post(`${Constants.port}/jobs/${customer._id}/update`,
                Object.assign(customer, { WorkorderNumber: res_data.data.newWO.Workorder.WorkorderNumber, createWO: true })
            );
            console.log("feting update job:", res_data_2)

            props.history.push(`/invoices/${res_data.data.newWO._id}`)

        } catch (error) {
            console.log("Error - asdz71s")
            if (error.response)
                props.setError({ show: true, message: error.response.data.error })
            else if (error.request)
                props.setError({ show: true, message: error.request })
            else
                props.setError({ show: true, message: props.error })
        }

    }

    async function removeJob(job) {
        try {
            const res_data = await axios.post(`${Constants.port}/jobs/${job._id}/remove`);
            console.log('fetching data REMOVEJOB: ', res_data);
        } catch (error) {
            console.log("testing CATCHING ERROR. removing job by ID ")
        }
    }

    function compareStatus(a, b) {

        if (a.Status === b.Status)
            return compareTime(a, b)

        const statusOrder = {
            'STARTED': 5,
            'OPEN': 4,
            'NEEDS APPROVAL': 3,
            'NEEDS PARTS': 2,
            'FINISHED': 1,
        };

        const statusA = statusOrder[a.Status] || 0;
        const statusB = statusOrder[b.Status] || 0;

        return statusB - statusA;

    }

    function compareDate(a, b) {
        if (!b.ScheduledDate)
            return -1
        if (a.ScheduledDate < b.ScheduledDate) {
            return -1;
        }
        if (a.ScheduledDate > b.ScheduledDate) {
            return 1;
        }
        return 0

    }

    function compareTime(a, b) {
        if (a.TimeIn < b.TimeIn) {
            return 1;
        }
        if (a.TimeIn > b.TimeIn) {
            return -1;
        }
        return 0;
    }

    function sortJobs(method) {
        sessionStorage.setItem("sortJobs", method)
        setSort(method)
        if (method === "Status") {
            let cpy = listOfJobs.filtered.sort(compareStatus)
            setListOfJobs({ ...listOfJobs, filtered: cpy })
        }
        else if (method === "Time") {
            let cpy = listOfJobs.filtered.sort(compareTime)
            setListOfJobs({ ...listOfJobs, filtered: cpy })
        }
    }

    function clickEditNote(item) {
        setModals({ ...modals, editNote: true })
        setEditItem(item)
    }

    useEffect(() => {
        getJobs();
        getNotes();
        getScheduledJobs();
        Constants.getEmployees().then(i=>setEmployees(i))


        socket.on('updateJobs', message => {
            console.log('updateJob -- Updating Jobs ClientSide -', message);
            setCount((c) => c + 1)
        })
        socket.on('updateNotes', message => {
            console.log('updateNotes -- Updating Notes ClientSide -', message);
            setCount((c) => c + 1)
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        getJobs();
        getNotes();
        getScheduledJobs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [count])

    function filterObjectsByString(arr, searchString) {
        if (!searchString) return arr; // return all if searchString is empty

        const lowerSearch = searchString.toLowerCase();

        return arr.filter(obj =>
            Object.values(obj).some(value =>
                String(value).toLowerCase().includes(lowerSearch)
            )
        );
    }

    useEffect(() => {
        setListOfJobs({ ...listOfJobs, filtered: filterObjectsByString(listOfJobs.jobs, filterJobs) })
    }, [filterJobs])

    useEffect(() => {
        if(apts.show)
                setApts({ ...apts, filtered: filterObjectsByString(apts.list, filterNotes) })
            else
                setNotes({ ...notes, filtered: filterObjectsByString(notes.notes, filterNotes) })
    }, [filterNotes])

    useEffect(()=>{
        setFilterNotes('')
        setApts({ ...apts, filtered: apts.list })
        setNotes({ ...notes, filtered: notes.notes })
    },[apts.show])

    return (
        <div style={{ display: "inline-flex", width: "100%", height: "100vh" }}>

            <div className="cardpadding_row" style={{ transition: "width 0.3s ease", width: notesOpen ? "70%" : "calc(100% - 22px)" }}>
                <Card style={{ overflowY: "scroll", height: "100%" }}>
                    <Card.Header style={{ fontSize: "35px", paddingRight: "10px" }}>
                        <Row style={{ margin: "auto" }}>
                            <Col>
                                <p style={{ margin: "auto" }} >Current Jobs{' '}</p>
                                <p style={{ fontSize: "18px", marginLeft: "10px", marginTop: "-8px", marginBottom: "auto"/* margin:"auto", */ }}>
                                    Total: {listOfJobs.jobs.length}
                                </p>
                            </Col>
                            <Col>
                                <Row>
                                    <Button
                                        style={{ marginTop: "10px", alignSelf: "center" }}
                                        onClick={() => setModals({ ...modals, addJob: true })}
                                        variant="primary">
                                        Add Job
                                    </Button>

                                    <DropdownButton /* onClick={()=>sort()} */ style={{ marginLeft: "8px", alignSelf: "center" }} title="View">
                                        <Dropdown.Item onClick={() => { setViewJobs("Both"); sessionStorage.setItem("viewJobs", "Both") }} >Both</Dropdown.Item>
                                        <Dropdown.Item onClick={() => { setViewJobs("Cards"); sessionStorage.setItem("viewJobs", "Cards") }} >Cards</Dropdown.Item>
                                        <Dropdown.Item onClick={() => { setViewJobs("Table"); sessionStorage.setItem("viewJobs", "Table") }}>Table</Dropdown.Item>
                                    </DropdownButton>
                                    
                                    <DropdownButton /* onClick={()=>sort()} */ style={{ marginLeft: "8px", alignSelf: "center" }} title="Sort By">
                                        <Dropdown.Item onClick={() => sortJobs("Status")} >Status</Dropdown.Item>
                                        <Dropdown.Item onClick={() => sortJobs("Time")}>Time</Dropdown.Item>
                                    </DropdownButton>

                                </Row>
                            </Col>
                            {/* <Button
                                style={{ marginLeft: "25px", alignSelf: "center" }}
                                onClick={() => setShowAddNewWOModal({show: true})}
                                variant="primary">
                                Create WO
                            </Button> */}
                            <Col id="legends">
                                <Row style={{ margin: "auto" }} >
                                    <Col>
                                        <Row style={{ fontSize: "12px" }}><div className="yellowdot_legend"></div> Open</Row>
                                        <Row style={{ fontSize: "12px" }}><div className="greendot_legend"></div> Started</Row>
                                        <Row style={{ fontSize: "12px" }}><div className="bluedot_legend"></div> Finished</Row>

                                    </Col>
                                    <Col >
                                        <Row style={{ fontSize: "12px" }}><div className="purpdot_legend"></div> Needs Approval</Row>
                                        <Row style={{ fontSize: "12px" }}><div className="reddot_legend"></div> Needs Parts</Row>

                                    </Col>
                                </Row>
                            </Col>

                        </Row>

                    </Card.Header>
                    <div style={{ paddingLeft: "18px", paddingRight: "18px", height:"100%" }} >

                        <div style={{  marginTop: "8px", width:"100%", marginRight:"8px" }}>
                            <FilterComponent text={filterJobs} setText={setFilterJobs} resetFilter={() => {
                                setListOfJobs({ ...listOfJobs, filtered: listOfJobs.jobs })
                                setFilterJobs('')
                            }}
                            />
                        </div>

                        <Row style={{height:"100%"}}>
                            {viewJobs === "Cards" || viewJobs === "Both" ?
                                listOfJobs.filtered.map((job, key) =>
                                    <JobCard
                                        job={job}
                                        key={key}
                                        employeeList={employees}
                                        onQuickUpdate={(updatedJob) => saveJobChanges(updatedJob)}
                                        onClick={() => setShowEditJobModal({ show: true, job: job })} />)
                                : null}

                            {viewJobs === "Table" || viewJobs === "Both" ? <JobsTable quickFilterText={filterJobs} sort={sort} jobs={listOfJobs.jobs} employees={employees} openJobModal={(job) => setShowEditJobModal({ show: true, job: job })} openWO={(job) => openWO(job)} saveJobChanges={(job) => saveJobChanges(job)} />
                                : null}
                        </Row>
                    </div>

                    {!loading ? null : <Loading component="JobsScreen" />}

                </Card>

                {modals.addJob ?
                    <AddJobModal
                        show={modals.addJob}
                        close={() => setModals({ ...modals, addJob: false, addScheduledJob: false })}
                        add={(newJob) => addJob(newJob)}
                        scheduled={modals.addScheduledJob}
                    />
                    : null}

                {showEditJobModal.show ?
                    <EditJobModal
                        employeeList={employees}
                        from="jobscreen"
                        show={showEditJobModal.show}
                        jobInfo={showEditJobModal.job}
                        moveJob={(job) => moveJob(job)}
                        save={(newJob) => saveJobChanges(newJob)}
                        remove={(job) => { removeJob(job); setShowEditJobModal({ show: false, job: null }) }}
                        close={() => setShowEditJobModal({ show: false, job: null })}
                        createWO={(job) => createWO_blank(job)}
                        openWO={(job) => openWO(job)}
                    />
                    : null}



            </div>

            <button className="notes-toggle-tab" onClick={() => toggleNotes()} title={notesOpen ? "Hide notes" : "Show notes"}>
                <MDBIcon icon={notesOpen ? "chevron-right" : "chevron-left"} />
                <span>{apts.show ? "Appointments" : "Notes"}</span>
            </button>

            <div className={`cardpadding_row_small notes-panel${notesOpen ? "" : " notes-panel-collapsed"}`}>
                <Card style={{ overflowY: "scroll", height: "100%" }}>
                    <Card.Header style={{ fontSize: "35px", paddingRight: "10px" }}>
                        <Row style={{ margin: "auto" }}>
                            <p >{apts.show ? "Appointments" : "Notes"}</p>
                            {apts.show ?
                                <Button
                                    style={{ marginLeft: "25px", alignSelf: "center" }}
                                    onClick={() => setModals({ ...modals, addJob: true, addScheduledJob: true })}
                                    variant="primary">
                                    Add Apt.
                                </Button>
                                :
                                <Button
                                    style={{ marginLeft: "25px", alignSelf: "center" }}
                                    onClick={() => setModals({ ...modals, addNote: true })}
                                    variant="primary">
                                    Add Note
                                </Button>
                            }

                            <Form style={{ fontSize: "15px", display: "inline-flex", position: "absolute", right: "10px" }}>
                                <p style={{ marginRight: "1rem" }}>Notes</p>
                                <Form.Check
                                    type="switch"
                                    id="view-switch"
                                    onClick={() => setApts({ ...apts, show: !apts.show })}
                                />
                                Appointments
                            </Form>
                        </Row>

                    </Card.Header>
                    <Container >
                        <Row>

                        <div style={{ marginLeft:"8px", marginTop: "8px", width:"100%", marginRight:"8px" }}>
                            <FilterComponent text={filterNotes} setText={setFilterNotes} resetFilter={() => {
                                setNotes({ ...notes, filtered: notes.notes })
                                setFilterNotes('')
                            }}
                            />
                        </div>

                            {apts.show ? apts.filtered.map((job, key) =>
                                <JobCard
                                    job={job}
                                    key={key}
                                    employeeList={employees}
                                    onQuickUpdate={(updatedJob) => saveJobChanges(updatedJob)}
                                    onClick={() => setShowEditJobModal({ show: true, job: job })}
                                />)
                                :
                                notes.filtered.map((item, key) =>
                                    <Card className="jobcard" style={{ zoom: "80%", width: '18rem', margin: "10px" }}
                                        item={item}
                                        key={key}
                                        onClick={() => clickEditNote(item)} >
                                        <Card.Body>
                                            <Card.Text>
                                                {item.Description}
                                            </Card.Text>
                                        </Card.Body>
                                    </Card>)}

                        </Row>
                    </Container>

                    {!loading ? null : <Loading component="JobsScreen" />}

                </Card>

                {modals.addNote ?
                    <NoteModal
                        edit={false}
                        show={modals.addNote}
                        close={() => setModals({ ...modals, addNote: false })}
                        add={(newNote) => addNote(newNote)}
                    />
                    : null}

                {modals.editNote ?
                    <NoteModal
                        edit={true}
                        show={modals.editNote}
                        close={() => setModals({ ...modals, editNote: false })}
                        add={(newNote) => addNote(newNote)}
                        update={(newNote) => updateNote(newNote)}
                        remove={(newNote) => removeNote(newNote)}
                        note={editItem}
                    />
                    : null}

            </div>

        </div>
    )
}